import { render, staticRenderFns } from "./LicenseExceeded.vue?vue&type=template&id=47c104b2&scoped=true&"
import script from "./LicenseExceeded.vue?vue&type=script&lang=js&"
export * from "./LicenseExceeded.vue?vue&type=script&lang=js&"
import style0 from "./LicenseExceeded.vue?vue&type=style&index=0&id=47c104b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c104b2",
  null
  
)

export default component.exports